import { EnergyMeterDto } from "./energyMeterDto"
import { ChargingStationDto } from "./chargingStationDto"
import { ChargingPointSignalColorDto } from "./ChargingPointSignalColorDto"

export class BlackboxSetup {
  serialNumber: string
  customerId: number
  addressId: number
  chargingStations: ChargingStationDto[]
  energyMeters: EnergyMeterDto
  chargingPointSignalColors: ChargingPointSignalColorDto[]

  constructor(formValue?: Partial<BlackboxSetup>) {
    Object.assign(this, formValue)
  }
  
  updateValues(formValue: Partial<BlackboxSetup>) {
    Object.assign(this, formValue)
  }
}
